var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("omegaup-login", {
        attrs: {
          "facebook-url": _vm.facebookUrl,
          "google-client-id": _vm.googleClientId
        },
        on: {
          login: function(username, password) {
            return _vm.$emit("login", username, password)
          }
        }
      }),
      _c("omegaup-signup", {
        attrs: {
          "has-visited-section": _vm.hasVisitedSection,
          "validate-recaptcha": _vm.validateRecaptcha,
          "use-signup-form-with-birth-date": _vm.useSignupFormWithBirthDate
        },
        on: {
          "register-and-login": function(request) {
            return _vm.$emit("register-and-login", request)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }